<template>
    <div>
       <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="7">
                        <v-card-title class="titulopagina">REPORTE DE STOCK REPASO MAXISACOS PENDIENTES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="green darken-1" class="float-right" small dark @click="download" v-bind:disabled="!can_download">Excel</v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="blue darken-1" class="float-right" small dark @click="cargarJumbosReprocesoPorAsignar()"><v-icon>loop</v-icon></v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                    <v-col cols="2">
                        <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-row>
            <v-col>
                <v-card>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="cabecera">Fecha</th>
                                <th class="cabecera">Lote</th>
                                <th class="cabecera">Maxisaco N°</th>
                                <th class="cabecera">TVN <small>(mgN/100)</small></th>
                                <th class="cabecera">Grasa (%)</th>
                                <th class="cabecera">Humedad (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="j in jumbos_por_repasar" :key="j.id">
                                <td class="text-center">{{j.fecha | formatearFecha}}</td>
                                <td class="text-center">{{j.nombre_lote}}</td>
                                <td class="text-center">{{j.nro_jumbo}}</td>
                                <td class="text-center">{{j.tvn}}</td>
                                <td class="text-center">{{j.grasa}}</td>
                                <td class="text-center">{{j.humedad}}</td>

                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        jumbos_por_repasar:[],
        fecha:'',
        url_excel: '',
        can_download: false,
    }),
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD');
        this.cargarJumbosReprocesoPorAsignar();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Stock Repaso Maxisacos Pendientes`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de cada lote de repaso de harina con maxisacos pendientes, con su respectivo número de maxisacos y parámetros de TVN, Grasa y Humedad hasta el día que se indica en el campo de fecha.`},
                {   tipo:`label`,   texto:`- Al cargar la página, se cargarán los lotes de repaso de harina con los maxisacos pendientes hasta el día actual. En caso de querer cargar información de días anteriores, se debe indicar en el campo de fecha ubicado arriba a la derecha de la página.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según la fecha indicada en formato Excel.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarJumbosReprocesoPorAsignar(){
          //this.mostrarLoading('Cargando Maxisacos a Reproceso Pendientes...');
            let url = `${this.base_url}jumbos_reproceso/por_asignar/${this.fecha}`;
            this.mostrarLoading({titulo:'Cargando Maxisacos a Reproceso Pendientes...',color:'green'});

            await this.axios.get(url,this.headers).then((response)=>{
                this.jumbos_por_repasar = response.data.data;
                this.url_excel = response.data.url;
                if(this.jumbos_por_repasar.length > 0){
                    this.can_download = true;
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        download(){
            window.location.href = this.url_excel;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas
    }
}
</script>